import { HTMLBnumFragment } from 'components/atoms/fragment/bnum-fragment';
import {
	CLASS_STATE_TEXT_ERROR,
	CLASS_STATE_TEXT_SUCCESS,
	DEFAULT_BUTTON_VARIATION,
	DEFAULT_INPUT_TYPE,
	ID_ERROR_TEXT,
	ID_HINT_TEXT,
	ID_HINT_TEXT_HINT,
	ID_HINT_TEXT_LABEL,
	ID_INPUT,
	ID_INPUT_BUTTON,
	ID_INPUT_ICON,
	ID_STATE,
	ID_STATE_ICON,
	ID_SUCCESS_TEXT,
	SLOT_BUTTON,
	SLOT_ERROR,
	SLOT_HINT,
	SLOT_SUCCESS,
	TEXT_INVALID_INPUT,
	TEXT_VALID_INPUT,
} from './constants';
import { EMPTY_STRING } from '@rotomeca/utils';
import { HTMLBnumIcon } from 'components/atoms/icon/bnum-icon';
import { HTMLBnumButton } from 'components/atoms/button';

export function Render(addonInner: Readonly<string> = EMPTY_STRING) {
	return (
		<HTMLBnumFragment>
			<label id={ID_HINT_TEXT} for={ID_INPUT} class="label-container">
				<span id={ID_HINT_TEXT_LABEL} class="label-container--label">
					<slot></slot>
				</span>
				<span id={ID_HINT_TEXT_HINT} class="label-container--hint hint-label">
					<slot name={SLOT_HINT}></slot>
				</span>
			</label>
			<div class="container">
				<div class="addons">
					<div class="addon__inner">
						{addonInner}
						<HTMLBnumIcon id={ID_INPUT_ICON}></HTMLBnumIcon>
						<input class="input-like" id={ID_INPUT} type={DEFAULT_INPUT_TYPE} />
					</div>
					<HTMLBnumButton
						id={ID_INPUT_BUTTON}
						rounded
						data-variation={DEFAULT_BUTTON_VARIATION}
					>
						<slot name={SLOT_BUTTON}></slot>
					</HTMLBnumButton>
				</div>
				<span id={ID_STATE} class="state" part="state-container">
					<HTMLBnumIcon id={ID_STATE_ICON} />
					<span id={ID_SUCCESS_TEXT} class={CLASS_STATE_TEXT_SUCCESS}>
						<slot name={SLOT_SUCCESS}>{TEXT_VALID_INPUT}</slot>
					</span>
					<span id={ID_ERROR_TEXT} class={CLASS_STATE_TEXT_ERROR}>
						<slot name={SLOT_ERROR}>{TEXT_INVALID_INPUT}</slot>
					</span>
				</span>
			</div>
		</HTMLBnumFragment>
	);
}
